import { useReveal } from "../hooks/useReveal";

const SERVICES = [
  {
    icon: "fa-comments",
    title: "Individual Psychotherapy",
    desc: "Evidence-based one-on-one sessions drawing on CBT, DBT and REBT — tailored to the architecture of your particular mind.",
  },
  {
    icon: "fa-wave-square",
    title: "Anxiety & Depression Counselling",
    desc: "Structured protocols for generalised anxiety, panic, social anxiety, and unipolar depression — often visibly easier within weeks.",
  },
  {
    icon: "fa-shield-heart",
    title: "Trauma & PTSD Recovery",
    desc: "Pacing-led, body-aware work for single-incident and complex trauma. We move only as fast as your nervous system permits.",
  },
  {
    icon: "fa-people-roof",
    title: "Couples & Relationship Therapy",
    desc: "Gottman-informed work on communication, repair, and the quiet erosions that pull two people apart before they notice.",
  },
  {
    icon: "fa-child-reaching",
    title: "Child & Adolescent Psychology",
    desc: "Play-based and cognitive approaches for anxiety, learning differences, school refusal, and the emotional weather of growing up.",
  },
  {
    icon: "fa-clipboard-list",
    title: "Psychometric & Career Counselling",
    desc: "Validated assessments — aptitude, personality, interest, intelligence — interpreted by a clinician, not a calculator.",
  },
];

export default function Services() {
  const ref = useReveal();
  const goToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section id="services" className="section services" ref={ref} data-testid="services-section">
      <div className="container">
        <div className="reveal reveal--up" style={{ maxWidth: 720 }}>
          <span className="eyebrow">Clinical Psychology Practice</span>
          <h2 className="section-title">Therapy that respects both the science and the soul.</h2>
          <span className="divider-leaf">Six Specialisms</span>
          <p className="section-lead" style={{ marginTop: 24 }}>
            These are the psychology services offered alongside, and independently of,
            the energy work. Each is delivered as structured, time-bound, evidence-based
            care — with the warmth and dignity every person deserves.
          </p>
        </div>

        <div className="service-grid stagger">
          {SERVICES.map((s, i) => (
            <article
              key={s.title}
              className="service-card reveal reveal--slide"
              role="button"
              tabIndex={0}
              onClick={goToContact}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  goToContact();
                }
              }}
              data-testid={`service-card-${i}`}
            >
              <span className="service-card__num">0{i + 1}</span>
              <div className="service-card__icon">
                <i className={`fa-solid ${s.icon}`}></i>
              </div>
              <h3 className="service-card__title">{s.title}</h3>
              <p className="service-card__desc">{s.desc}</p>
              <span className="service-card__arrow">
                Learn More <i className="fa-solid fa-arrow-right"></i>
              </span>
            </article>
          ))}
        </div>

        <p className="services__quote reveal reveal--up">
          "The privilege of a lifetime is to become who you truly are — and therapy,
          done well, is simply the slow, careful unwrapping of that person."
        </p>
      </div>
    </section>
  );
}
